'use client'

import Link from 'next/link'
import clsx from 'clsx'

import { trackEvent, type UmamiEventData } from '@/lib/umami'

type ButtonProps = {
  invert?: boolean
  event?: string
  eventData?: UmamiEventData
} & (
  | React.ComponentPropsWithoutRef<typeof Link>
  | (React.ComponentPropsWithoutRef<'button'> & { href?: undefined })
)

export function Button({
  invert = false,
  className,
  children,
  event,
  eventData,
  onClick,
  ...props
}: ButtonProps) {
  className = clsx(
    className,
    'inline-flex rounded-full px-4 py-1.5 text-sm font-semibold transition ',
    invert
      ? 'bg-white text-zinc-950 hover:bg-zinc-200'
      : 'bg-zinc-950 text-white hover:bg-zinc-800',
  )

  let inner = <span className="relative top-px">{children}</span>

  function handleClick(
    e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>,
  ) {
    if (event) {
      trackEvent(event, eventData)
    }
    onClick?.(e as never)
  }

  if (typeof props.href === 'undefined') {
    return (
      <button className={className} {...props} onClick={handleClick}>
        {inner}
      </button>
    )
  }

  return (
    <Link className={className} {...props} onClick={handleClick}>
      {inner}
    </Link>
  )
}
